import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { EmailContentModel, ChaseResponseModel } from "../models/ChasableModels";
import { useSWRFetcher } from "./useSWRFetcher";

export const useChaseInvoice = (invoiceId: string | null | undefined, isNew: boolean = false) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);
  const endpoint = isNew
    ? `${environment.apiUrl}/api/chases/initial/external/${invoiceId}`
    : `${environment.apiUrl}/api/chases/external/${invoiceId}`;

  const { trigger, isMutating, error } = useSWRMutation(
    invoiceId ? endpoint : null,
    (url, { arg }: { arg?: { rewriteEmail?: EmailContentModel | undefined; language?: string } }) =>
      fetcher<ChaseResponseModel>(url, {
        method: "POST",
        body: JSON.stringify(arg || {}),
      }),
    {
      onSuccess: (resp) => {
        if (!resp.attachments || resp.attachments.length === 0) {
          showToast("Couldn't find the attachment required for this email. Please check the missing file", "warning");
        }
      },
      onError: () => {
        showToast("Failed to chase the invoice, please try again later", "error");
      },
    }
  );

  return {
    chaseInvoice: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
